// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1ek14","title":"Info_title__2zzCT","selects":"Info_selects__3VVUD","requiredAsterisk":"Info_requiredAsterisk__1A2cG"};